/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerApplicationStatus } from './';
import {
    FreelancerApplicationStatusFromJSON,
    FreelancerApplicationStatusFromJSONTyped,
    FreelancerApplicationStatusToJSON,
} from './';
import type { FreelancerDetailsResource } from './';
import {
    FreelancerDetailsResourceFromJSON,
    FreelancerDetailsResourceFromJSONTyped,
    FreelancerDetailsResourceToJSON,
} from './';
import type { RepatriationOpportunityGroupSummaryResource } from './';
import {
    RepatriationOpportunityGroupSummaryResourceFromJSON,
    RepatriationOpportunityGroupSummaryResourceFromJSONTyped,
    RepatriationOpportunityGroupSummaryResourceToJSON,
} from './';
import type { RepatriationOpportunityQuoteResource } from './';
import {
    RepatriationOpportunityQuoteResourceFromJSON,
    RepatriationOpportunityQuoteResourceFromJSONTyped,
    RepatriationOpportunityQuoteResourceToJSON,
} from './';
import type { RepatriationOpportunityState } from './';
import {
    RepatriationOpportunityStateFromJSON,
    RepatriationOpportunityStateFromJSONTyped,
    RepatriationOpportunityStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityResource
 */
export interface RepatriationOpportunityResource {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityResource
     */
    id: string;
    /**
     * 
     * @type {RepatriationOpportunityGroupSummaryResource}
     * @memberof RepatriationOpportunityResource
     */
    group: RepatriationOpportunityGroupSummaryResource;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityResource
     */
    authorAccountId: string;
    /**
     * 
     * @type {FreelancerDetailsResource}
     * @memberof RepatriationOpportunityResource
     */
    freelancer: FreelancerDetailsResource;
    /**
     * 
     * @type {FreelancerApplicationStatus}
     * @memberof RepatriationOpportunityResource
     */
    freelancerApplicationStatus: FreelancerApplicationStatus;
    /**
     * 
     * @type {RepatriationOpportunityState}
     * @memberof RepatriationOpportunityResource
     */
    currentState: RepatriationOpportunityState;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityResource
     */
    projectConversationId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RepatriationOpportunityResource
     */
    creationDate: Date;
    /**
     * 
     * @type {RepatriationOpportunityQuoteResource}
     * @memberof RepatriationOpportunityResource
     */
    mostRelevantQuote?: RepatriationOpportunityQuoteResource;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityResource
     */
    mostRelevantProjectId?: string;
}

/**
 * Check if a given object implements the RepatriationOpportunityResource interface.
 */
export function instanceOfRepatriationOpportunityResource(value: object): value is RepatriationOpportunityResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('authorAccountId' in value) || value['authorAccountId'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('freelancerApplicationStatus' in value) || value['freelancerApplicationStatus'] === undefined) return false;
    if (!('currentState' in value) || value['currentState'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityResourceFromJSON(json: any): RepatriationOpportunityResource {
    return RepatriationOpportunityResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'group': RepatriationOpportunityGroupSummaryResourceFromJSON(json['group']),
        'authorAccountId': json['authorAccountId'],
        'freelancer': FreelancerDetailsResourceFromJSON(json['freelancer']),
        'freelancerApplicationStatus': FreelancerApplicationStatusFromJSON(json['freelancerApplicationStatus']),
        'currentState': RepatriationOpportunityStateFromJSON(json['currentState']),
        'projectConversationId': json['projectConversationId'] == null ? undefined : json['projectConversationId'],
        'creationDate': (new Date(json['creationDate'])),
        'mostRelevantQuote': json['mostRelevantQuote'] == null ? undefined : RepatriationOpportunityQuoteResourceFromJSON(json['mostRelevantQuote']),
        'mostRelevantProjectId': json['mostRelevantProjectId'] == null ? undefined : json['mostRelevantProjectId'],
    };
}

export function RepatriationOpportunityResourceToJSON(value?: RepatriationOpportunityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'group': RepatriationOpportunityGroupSummaryResourceToJSON(value['group']),
        'authorAccountId': value['authorAccountId'],
        'freelancer': FreelancerDetailsResourceToJSON(value['freelancer']),
        'freelancerApplicationStatus': FreelancerApplicationStatusToJSON(value['freelancerApplicationStatus']),
        'currentState': RepatriationOpportunityStateToJSON(value['currentState']),
        'projectConversationId': value['projectConversationId'],
        'creationDate': ((value['creationDate']).toISOString()),
        'mostRelevantQuote': RepatriationOpportunityQuoteResourceToJSON(value['mostRelevantQuote']),
        'mostRelevantProjectId': value['mostRelevantProjectId'],
    };
}

